import { useEffect, useState } from 'react'
import { fetchReviewsForSubject, fetchReviewAggregates, type Review, type ReviewAggregate } from '../api/reviews'

export function useReviews(subjectId?: number) {
  const [reviews, setReviews] = useState<Review[] | null>(null)
  const [aggregate, setAggregate] = useState<ReviewAggregate | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!subjectId) return
    let cancelled = false
    setLoading(true)
    setError(null)
    ;(async () => {
      try {
        const [agg, list] = await Promise.all([
          fetchReviewAggregates(subjectId),
          fetchReviewsForSubject(subjectId),
        ])
        if (cancelled) return
        setAggregate(agg)
        setReviews(Array.isArray((list as any)?.results) ? (list as any).results : [])
      } catch (e: any) {
        if (!cancelled) setError(e?.message || 'Failed to load reviews')
      } finally {
        if (!cancelled) setLoading(false)
      }
    })()
    return () => { cancelled = true }
  }, [subjectId])

  return { reviews, aggregate, loading, error }
}

